import { useEffect } from 'react';
import { all, isEmpty, pathOr } from 'ramda';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';

const useTelEmailValidation = (form, getMiddleBoolean, isSimulationForm = false) => {
  const requiredWith = {
    emailOrMobile:
      getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_NECESSAIRE') &&
      getMiddleBoolean('ADHERENT_EMAIL_EST_NECESSAIRE') &&
      (isSimulationForm
        ? getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_DEMANDE_DONNEES_CONTRAT') &&
        getMiddleBoolean('ADHERENT_EMAIL_EST_DEMANDE_DONNEES_CONTRAT')
        : getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_DEMANDE_DONNEES_SOUSCRIPTION') &&
        getMiddleBoolean('ADHERENT_EMAIL_EST_DEMANDE_DONNEES_SOUSCRIPTION')) &&
      getMiddleBoolean('ADHERENT_TEL_MOBILE_EMAIL_EST_OBLIGATOIRE'),
    emailOrLandline:
      getMiddleBoolean('ADHERENT_TEL_FIXE_EST_NECESSAIRE') &&
      getMiddleBoolean('ADHERENT_EMAIL_EST_NECESSAIRE') &&
      (isSimulationForm
        ? getMiddleBoolean('ADHERENT_TEL_FIXE_EST_DEMANDE_DONNEES_CONTRAT') &&
        getMiddleBoolean('ADHERENT_EMAIL_EST_DEMANDE_DONNEES_CONTRAT')
        : getMiddleBoolean('ADHERENT_TEL_FIXE_EST_DEMANDE_DONNEES_SOUSCRIPTION') &&
        getMiddleBoolean('ADHERENT_EMAIL_EST_DEMANDE_DONNEES_SOUSCRIPTION')) &&
      getMiddleBoolean('ADHERENT_TEL_FIXE_EMAIL_EST_OBLIGATOIRE'),
    landlineOrMobile:
      getMiddleBoolean('ADHERENT_TEL_FIXE_EST_NECESSAIRE') &&
      getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_NECESSAIRE') &&
      (isSimulationForm
        ? getMiddleBoolean('ADHERENT_TEL_FIXE_EST_DEMANDE_DONNEES_CONTRAT') &&
        getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_DEMANDE_DONNEES_CONTRAT')
        : getMiddleBoolean('ADHERENT_TEL_FIXE_EST_DEMANDE_DONNEES_SOUSCRIPTION') &&
        getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_DEMANDE_DONNEES_SOUSCRIPTION')) &&
      getMiddleBoolean('ADHERENT_TEL_FIXE_MOBILE_EST_OBLIGATOIRE'),
    emailOrLandlineOrMobile:
      getMiddleBoolean('ADHERENT_TEL_FIXE_EST_NECESSAIRE') &&
      getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_NECESSAIRE') &&
      getMiddleBoolean('ADHERENT_EMAIL_EST_NECESSAIRE') &&
      (isSimulationForm
        ? getMiddleBoolean('ADHERENT_TEL_FIXE_EST_DEMANDE_DONNEES_CONTRAT') &&
        getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_DEMANDE_DONNEES_CONTRAT') &&
        getMiddleBoolean('ADHERENT_EMAIL_EST_DEMANDE_DONNEES_CONTRAT')
        : getMiddleBoolean('ADHERENT_TEL_FIXE_EST_DEMANDE_DONNEES_SOUSCRIPTION') &&
        getMiddleBoolean('ADHERENT_TEL_MOBILE_EST_DEMANDE_DONNEES_SOUSCRIPTION') &&
        getMiddleBoolean('ADHERENT_EMAIL_EST_DEMANDE_DONNEES_SOUSCRIPTION')) &&
      getMiddleBoolean('ADHERENT_TEL_MOBILE_FIXE_EMAIL_EST_OBLIGATOIRE')
  };

  const emailValue = form.watch('customer.emails.0.value');
  const landlineValue = form.watch('customer.phones.1.number');
  const mobileValue = form.watch('customer.phones.0.number');

  const areAllEmpty = all(isNilOrEmpty);

  useEffect(() => {
    form.clearErrors('telEmail');

    if (requiredWith.emailOrMobile && areAllEmpty([emailValue, mobileValue])) {
      form.setError('telEmail', {
        type: 'custom',
        message: 'L\'email et/ou le numéro de téléphone mobile sont obligatoires'
      });
    }

    if (requiredWith.emailOrLandline && areAllEmpty([emailValue, landlineValue])) {
      form.setError('telEmail', {
        type: 'custom',
        message: 'L\'email et/ou le numéro de téléphone fixe sont obligatoires'
      });
    }

    if (requiredWith.landlineOrMobile && areAllEmpty([landlineValue, mobileValue])) {
      form.setError('telEmail', {
        type: 'custom',
        message: 'Le numéro de téléphone fixe et/ou mobile sont obligatoires'
      });
    }

    if (
      requiredWith.emailOrLandlineOrMobile &&
      areAllEmpty([emailValue, landlineValue, mobileValue])
    ) {
      form.setError('telEmail', {
        type: 'custom',
        message: 'L\'email et/ou le numéro de téléphone fixe et/ou mobile sont obligatoires'
      });
    }
  }, [emailValue, landlineValue, mobileValue]);

  return {
    telEmailValidationHasError: !isEmpty(
      pathOr({}, ['formState', 'errors', 'telEmail', 'message'], form)
    ),
    telEmailValidationErrorMessage: pathOr('', ['formState', 'errors', 'telEmail', 'message'], form)
  };
};

export default useTelEmailValidation;
